import dynamic from 'next/dynamic';
import { LaunchDarklyToolbar } from '@launchdarkly/toolbar';
import { eventInterceptionPlugin, flagOverridePlugin } from '../utils/launch-darkly';

const LDToolbar = () => (
    <LaunchDarklyToolbar
        flagOverridePlugin={flagOverridePlugin}
        eventInterceptionPlugin={eventInterceptionPlugin}
    />
);

export default dynamic(() => Promise.resolve(LDToolbar), { ssr: false });
